import {
  getApiV1ThreeLetterCodeClientAdminsPrefectures,
  getGetApiV1ThreeLetterCodeClientAdminsPrefecturesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsPrefectures200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

/**
 * 都道府県一覧取得（GET /api/v1/{tlc}/client_admins/prefectures）API hook
 *
 * @returns 都道府県一覧
 */
export const useGetPrefectures = (
  threeLetterCode: string
): { data: GetApiV1ThreeLetterCodeClientAdminsPrefectures200 } =>
  useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsPrefecturesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodeClientAdminsPrefectures(threeLetterCode),
    { suspense: true }
  );
